module.exports = __webpack_public_path__ + "static/media/zephyrtone.bec3546c.png";